import {
    Grid,
    Button,
    Typography,
} from "@material-ui/core";
import { Link, useParams } from "react-router-dom";
import React from 'react'
import { message } from "antd";
import UploadedFiles from "./UploadedFiles";
import { LabelIncident } from "../../helpers/textValidation";

const AttachFilesIncident = ({ data }) => {
    let { additionalFiles, setAdditionalFiles, removeFile, uploadedFiles, incidentId } = data

    const validTypes = ['image/png', 'image/jpeg', 'image/JPEG', 'image/PNG', 'image/JPG', 'image/jpg', 'application/msword', 'application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']

    const clearAdditionalFiles = () => {
        additionalFiles.value = null;
        setAdditionalFiles([]);
    };


    let uploadData = {
        files: uploadedFiles,
        head: "Uploaded Documents",
        path: `employee/incident/download?id=${incidentId}`
    }
    return <Grid xs={12} container>
        <Grid xs={12}>
            {
                <Grid xs={12} lg={12} container>
                    <Grid xs={12} className="">
                        {!additionalFiles.length
                            ? (
                                <Grid xs={12}>

                                    <Grid xs={12} id="Step2DragFile" className="Step2DragFile mt14">
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px", }}>
                                            <Button
                                                style={{ background: "lightgray", width: "130px" }}
                                                onClick={($event) => {
                                                    const input = document.getElementById('additional-files-input');

                                                    input.click();
                                                }}>Upload</Button>
                                            <span style={{ fontSize: "10px", color: "lightgray" }}>Acceptable formats (JPG, PNG, Word, PDF)</span>
                                        </div>
                                    </Grid>
                                    <input
                                        id="additional-files-input"
                                        type="file"
                                        multiple="multiple"
                                        hidden="true"
                                        onChange={($event) => {
                                            let validImages = []
                                            Object.values($event.target.files)?.forEach(x => {
                                                message.destroy()
                                                if (!validTypes.includes(x?.type)) return message.error("Unacceptable format!")
                                                validImages.push(x)

                                            })
                                            setAdditionalFiles(validImages);
                                        }}
                                    />
                                </Grid>)
                            :
                            (<div className="upload-files-container">
                                {Array
                                    .from(additionalFiles)
                                    .map(
                                        (file, fileIndex) => (
                                            <Grid className="upload-files-tag  position-relative">
                                                <Grid className="d-flex justify-content-end position-absolute r-0">
                                                    <Button
                                                        className="dustbinBtn min-width-auto dustbinBtn-size-auto-100"
                                                        onClick={
                                                            $e => {
                                                                removeFile(fileIndex)
                                                            }
                                                        }></Button>
                                                </Grid>
                                                <p className="attatchmentTag">
                                                    {file.name}
                                                </p>
                                            </Grid>))}
                                <Grid xs={12} className="mt12 pr70">
                                    <Grid xs={12} container >
                                        {
                                            additionalFiles?.length ? <span
                                                onClick={clearAdditionalFiles}
                                                className="upload-btn"
                                                style={{ padding: '1px' }}>
                                                Clear All
                                            </span> : <></>}
                                    </Grid>
                                </Grid>
                            </div>)}
                        <UploadedFiles data={uploadData} />

                    </Grid>
                </Grid>
                // : ""
            }
        </Grid >


    </Grid >



}

export default AttachFilesIncident